import { Toggle } from '@warp-ds/react/components/toggle';
import { thousandSeparated } from 'shared/util/formatting';
import type { LmsLocationFacet } from '@/interfaces/lms';

export type NestedCheckboxFilterProps = {
    facet: LmsLocationFacet;
    ancestors: string[];
    checked: string[];
    onChange: (value: string[]) => void;
};

export const NestedCheckboxFilter = ({ facet, ancestors, checked, onChange }: NestedCheckboxFilterProps) => {
    const isChecked = checked.includes(facet.name);
    const isDisabled = facet.count === 0 && !isChecked;

    const hasChildren = facet.children?.length > 0;

    const displayValue = (
        <>
            {facet.text}
            {facet.count !== undefined && <span className="text-s s-text-subtle ml-8">({thousandSeparated(facet.count)})</span>}
        </>
    );

    const renderNestedChild = (child: LmsLocationFacet) => (
        <NestedCheckboxFilter
            key={child.name.replace(' ', '_')}
            facet={child}
            ancestors={[...ancestors, facet.name]}
            checked={checked}
            onChange={onChange}
        />
    );

    return (
        <>
            <Toggle
                type="checkbox"
                label={displayValue}
                checked={isChecked}
                disabled={isDisabled}
                onChange={() => onChange([...ancestors, facet.name])}
                data-testid={`destination-${facet.name.replace(' ', '_')}`}
            />
            {isChecked && hasChildren && (
                <div className="ml-16 space-y-8">{facet.children.sort((a, b) => b.count - a.count).map(renderNestedChild)}</div>
            )}
        </>
    );
};
